import React, { useState, useEffect, useRef } from 'react';
import Header from './header/Header';
import Sidebar from './sidebar/Sidebar';
import styles from './Layout.module.scss';

const Layout: React.FC<{ children: React.ReactNode; role?: string }> = ({ 
  children, 
  role
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
      <div className={styles.layout}>
        <Header onMenuToggle={toggleSidebar} />
        <div className={styles.body}>
          {/* Mobile sidebar overlay */}
          <div 
            className={`${styles.sidebarOverlay} ${sidebarOpen ? styles.active : ''}`}
            onClick={closeSidebar}
          />
          
          {/* Sidebar container */}
          <div className={`${styles.sidebarContainer} ${sidebarOpen ? styles.active : ''}`}>
            <Sidebar 
              role={role} 
              onClose={closeSidebar}
              isMobile={sidebarOpen}
            />
          </div>
          
          <main className={styles.main}>
            {children}
          </main>
        </div>
      </div>
  );
};

export default Layout; 